import { atomWithStorage } from "jotai/utils";
import { ABILITY_RULES_KEY } from "../common/env";

export const AbilityRulesStore = atomWithStorage<Array<any>>(ABILITY_RULES_KEY, [], undefined, { getOnInit: true });
